import { render, staticRenderFns } from "./DisplayStatAverageCoaches.vue?vue&type=template&id=c1f70968"
import script from "./DisplayStatAverageCoaches.vue?vue&type=script&lang=js"
export * from "./DisplayStatAverageCoaches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports